<template>
  <div class='privacy_wrap'>
    <div class='p_top'>
      <h1>Privacy Policy</h1>
    </div>
    <div class="p_title">
      <h2>Introduction</h2>
      <p>Welcome to 51Talk American Academy, a web-based service that teaches English to young learners. We respect your privacy and want you to know what information we collect and what we do with that information. This Privacy Policy applies to all information we collect or receive from you. </p>
    </div>
    <div class="register_info">
      <ul>
        <li v-for='info in datas'>
          <fold :title='info.title' :partOne='info.article.partOne' :partTwo='info.article.partTwo' :partTh='info.article.partTh'></fold>
        </li>
      </ul>
    </div>
    <div></div>
  </div>
</template>

<script>
import fold from '@common/fold'

export default {
  data() {
    return {
      datas: [
        {
          title: 'Registration information',
          article: {
            partOne: '',
            partTwo:
              'When you create your 51Talk Teacher Account, you will be required to provide certain personal information including: your first and last name, the country/state/city in which you reside, your highest level of education, your teaching experience, your resume, and your phone number. ',
            partTh: ''
          }
        },
        {
          title: 'Automatic Collection of Data',
          article: {
            partOne: '',
            partTwo:
              'When you visit our Website or click through hyperlinks appearing thereon, or use one or more of our services, we may use an industry-wide technology called "cookies" which stores certain information on your computer and which will allow us to customize your experience to better match your interests and preferences or simply facilitate your signing-in to use the services. Most browsers will allow you to erase cookies from your computer hard drive, block acceptance of cookies, or receive a warning before a cookie is stored. Please refer to your browser instructions or help screen to learn more about these functions. Please note, however, that if you set your browser to block acceptance of cookies, you may not be able to use the Service or enter our Website or it may otherwise adversely impact the functionality of the site. By allowing your browser settings to accept cookies from this Website or Service, you consent to our placement of cookies on your personal computer and/or technology device.',
            partTh:
              'If you do not wish to share this information with 51Talk, then you should take steps to limit the passive collection of data about your activities on our site, for example, by changing your browser settings to disable cookies. We reserve the right to use and disclose such Non Personal Information, as well as any other Non-Personal Information we collect, with our advertisers and other third parties at our discretion.'
          }
        },
        {
          title: 'Social media features and widgets',
          article: {
            partOne: '',
            partTwo:
              'Our Site includes social media features and widgets, such as the Facebook “Like” button and the Facebook “Share” button. These features may collect your IP address, the URL of the page you are visiting on our site, and may set a cookie to enable the feature to function properly. Social media features and widgets are either hosted by a third party or hosted directly on our site. Your interactions with these features are governed by the privacy policy of the company providing it.',
            partTh: ''
          }
        },
        {
          title: 'What we do with your information',
          article: {
            partOne: '',
            partTwo:
              'In general, the Personal Information we collect is used to (1) improve our services and enhance your experience, (2) enable us to provide a safer community for all of our Registered Users, and (3) communicate with us. We may use your Personal Information to register and service your account, including teacher profiles, contact you for questions and to solicit feedback, enable students to search for you, verify information you provide us, help protect the safety and integrity of the site, target promotional messages or content on the site, via email or other ads.',
            partTh: ''
          }
        },
        {
          title: 'Sharing Information with Affiliates',
          article: {
            partOne: '',
            partTwo:
              "From a teacher recruitment website to the 51Talk main website which is open to company members; your information will be stored in 51Talk's database, which is only accessible through the use of a Virtual Private Network (VPN) with access restricted to only a few key members in the company. Following termination or deactivation of your account, 51Talk, its affiliates, or its service providers may retain information associated with your profile information for a commercially reasonable time for backup, archival, and/or audit purposes.",
            partTh: ''
          }
        },
        {
          title: 'Share information with third parties',
          article: {
            partOne: '',
            partTwo:
              'We work with third parties who provide services, which may include website hosting, bank payment and other services of an administrative nature. Personal information, including financial information, may be shared with such third parties for the purpose of providing such services to you. We seek to impose confidentiality obligations on such service providers.',
            partTh: ''
          }
        },
        {
          title: 'Registered students and parents',
          article: {
            partOne: '',
            partTwo:
              'If you are a teacher, in order to increase your class booking rate, we share with registered users the information that is included in your profile, aside from your contact information, as well as the following registration information, which we may include in your profile: your first name, first initial of your last name, city, state, profile picture, your gender and your age.',
            partTh: ''
          }
        },
        {
          title: 'Links to other sites',
          article: {
            partOne: '',
            partTwo:
              'Linking to other sites is an integral part of the functionality of the Internet, including our Website. Any link to a page which displays a URL other than a domain name that ends in 51talk.com.cn in the address window of your browser is a link to a site outside of our service and thus outside the control of 51Talk. This includes links to our suppliers of content on the service, affiliates, and links to any other third parties that may be linked to 51Talk. These other sites may send their own cookies, collect data or solicit personal information. 51Talk cannot guarantee and is not responsible for the content of outside sites.',
            partTh: ''
          }
        },
        {
          title: 'Not to use for profit (rent or sell)',
          article: {
            partOne: '',
            partTwo:
              'If you provide 51Talk with personally identifiable information, we will take reasonable and appropriate steps to protect this information. Except as otherwise described in this privacy policy, 51Talk will not disclose, share, sell or rent personally identifiable information collected on our site to third-party organizations for their marketing or promotional use without your consent or except as part of a specific program or feature for which you will have the ability to opt-out. If we sell or otherwise transfer part or the whole of 51Talk business and/or our assets to another organization like in a course of a merger and acquisition transaction, or in the case of a bankruptcy, dissolution or liquidation, your information such as name and email address and any other information collected through our site or service may be among the items sold or transferred. The resulting buyer, surviving company or transferee will honor the commitments we have made in this privacy policy. We do not share your bank account information with affiliate sites or any other third parties, other than making salary payments for teachers.',
            partTh: ''
          }
        },
        {
          title: 'Updating or deleting your registration information',
          article: {
            partOne: '',
            partTwo:
              'As part of your use of our service, you are responsible for updating your submitted registration information so that it is current, complete and effective. You can update this information by logging into your account and accessing your account settings. If you would like to remove some of the personal information you have posted on the site, such as information you posted in profiles, you may do so by editing or deleting that item. To request removal of other personal information you have voluntarily posted on our site, such as information you may have posted in online group forums, contact 51Talk. In some cases, we may not be able to reasonably accommodate your request to remove your personal information, in which case we will let you know if we are unable to do so and why. Please note that by using our website, you signify your agreement to this privacy policy, as it may be amended from time to time. If you do not agree to this privacy policy, please do not use our site or the services provided thereon. We reserve the right to make changes to this privacy policy. We will provide notice to you of any material changes by any reasonable means including sending an email to the most recently updated address in your 51Talk Account and/or posting such notice and the amended policy on your 51Talk My Page. Your continued use of our site following changes to this privacy policy will mean that you accept and agree to the changes and that any information collected or provided after such change will be governed by the updated privacy policy.',
            partTh: ''
          }
        },
        {
          title: 'Invitations - Refer a Friend',
          article: {
            partOne: '',
            partTwo:
              'If you decide to refer a friend to our site, they will have to provide information for registration as outlined above. Your friend will be subject to this privacy policy and the terms of service of 51Talk.',
            partTh: ''
          }
        },
        {
          title: 'Security',
          article: {
            partOne: '',
            partTwo:
              'Whenever you give 51Talk sensitive information (e.g., bank information), 51Talk will take commercially reasonable steps to protect such information. We use reasonable security methods to protect the data that resides on our servers. However, because no security system is impenetrable, we cannot guarantee the security of our servers. It is also possible that information you supply to us will be intercepted during transmission. Please remember to sign out of your 51Talk account and close your browser window whenever you leave your computer. This is to ensure that others cannot access your personal information, because your computer may be accessible to others or used in a shared setting. To help protect your 51Talk account information, please keep your password secure. Your password will be maintained in our system in encrypted form. Ultimately, you are responsible for maintaining the secrecy of your passwords and any 51Talk account information. ',
            partTh: ''
          }
        }
      ]
    }
  },
  components: {
    fold
  },
  methods: {}
}
</script>

<style lang='less' scoped>
.privacy_wrap {
  .p_top {
    height: 228px;
    background: url('~@img/page_top_bg.jpg') no-repeat center 0;
    h1 {
      width: 1000px;
      margin: 0 auto;
      padding-top: 102px;
      font-weight: bold;
      font-size: 36px;
      color: #1e1e1e;
    }
  }
  .p_title {
    width: 1000px;
    margin: 0 auto;
    h2 {
      font-size: 20px;
      color: #999999;
      font-weight: bold;
      margin-top: 60px;
    }
    p {
      margin-top: 28px;
      font-size: 14px;
      color: #999999;
      line-height: 25px;
    }
  }
  .register_info {
    width: 1000px;
    padding: 33px 0 132px 0;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// privacy_policy.vue?f2b9c4b2